import React, {useEffect, useImperativeHandle, useRef, useState} from 'react'
import WizModal from '../../../components/modal/WizModal'
import Text from '../../../components/text/Text'
import WizButton from '../../../components/button/WizButton'
import UnderLineInput from '../../../components/input/UnderLineInput'
import {postEditUserReferral} from '../../../apis/user/editReferral'

interface IProps {
    className?: string
    status: string
    userId: string
    refetch?: any
}

const ChangedUserReferralModal = ({className, status, userId, refetch}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const [userStatus, setUserStatus] = useState('')

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    useEffect(() => {
        setUserStatus(status)
    }, [status])

    const onClickSubmit = async () => {
        await postEditUserReferral({id: userId, my_referral_code: userStatus})
        refetch()
        modalRef.current.close()
    }

    return (
        <>
            <WizModal title={'Changed Referral Code'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>변경하려는 레퍼럴 코드를 입력해 주세요. </Text>
                <UnderLineInput value={userStatus} className={'mt-[10px]'} onChanged={setUserStatus} />
                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton
                        text={'Submit'}
                        type={'blue'}
                        className={'flex-1'}
                        onClick={async () => onClickSubmit()}
                    />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(ChangedUserReferralModal)
